<div class="modal-header" mat-dialog-title>
    <h5 class="modal-title">Copy Images</h5>
    <a class="modal-close" mat-dialog-close>&#10005;</a>
</div>
<mat-dialog-content class="mat-add-image">
    <div class="modal-body">
        <div class="information d-flex">
            <div class="col-md-6">
                <ul class="ul-list">
                    <li>Check the boxes to select/unselect images</li>
                    <li>Enter a Mailing</li>
                    <li>Click Copy button</li>
                </ul>
            </div>
            <div class="col-md-6">
                <label class="specimen-upload text-right"><strong>Mailing:</strong> {{mailingID}}</label>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="alert-error" *ngIf="errorList.length > 0">
                    <p *ngFor="let error of errorList" class="error-msg">{{error}}</p>
                </div>
            </div>
            <div class="col-md-8">
                <div class="internal-image-block">
                    <label class="internal-label">&nbsp;</label>
                    <table class="table table-striped" aria-describedby="table">
                        <tr>
                            <th id="select"> <input type="checkbox" name="specimen" value="all" [(ngModel)]="isSelectedAll" (change)="onChangeSpecimen($event, 'all')" /> Specimen</th>
                            <th id="sequence">Sequence #</th>
                            <th id="image-source">Image Source Name</th>
                        </tr>
                        <tr *ngFor="let image of copyImageRows">
                            <td> <label> <input type="checkbox" name="specimen" value="{{image.specimenCode}}" [(ngModel)]="image.isSelected" (change)="onChangeSpecimen($event, image)" /> {{ (image.specimenCode !== '') ? image.specimenCode : mailingID }} </label></td>
                            <td>{{image.sequence}}</td>
                            <td>{{image.name}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="col-md-4">
                <div class="internal-image-block">
                    <label class="internal-label">Mailing</label>
                </div>
                <div class="form-group" *ngFor="let mailing of mailingRows">
                    <input type="text" class="form-control" [(ngModel)]="mailing.value" (keyup)="onKeyUpMailing($event)" maxlength="15" />
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="start">
    <button mat-button class="save-btn" [disabled]="isCopyBtnDisable" (click)="clickCopyImageButton()">Copy</button>
    <button mat-button mat-dialog-close class="cancel-btn">Cancel</button>
</mat-dialog-actions>